import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import EmptyLine from "../../EmptyLine";
import StationElevationPlot from "../UI/StationElevationPlot";
import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";

export function B14({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const StaElevPlot = ({riverStation, globalVariables, layers}) => {
    return (
        <>
            <StationElevationPlot
                crossSection={riverStation?.cross_section}
                plotData={{
                    base: riverStation?.plot_base,
                    cmp: riverStation?.plot_cmp
                }}
                globalVariables={globalVariables}
                layers={layers}
            />
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.LS01.error_id: {
            return (
                <>
                    <ResultText>
                        The thalweg is not within bank stations at the following {row?.data?.length} cross sections.
                        <EmptyLine />
                        <CheckCSName csNameList={row?.data?.map(x => x.cross_section)} />
                    </ResultText>
                </>
            )
        }
    }
}